module.exports = __webpack_public_path__ + "static/media/repair-so.18a349eb.svg";